export default {
  text_one: 'Câștigă {{count}} punct',
  text_few: 'Câștigă {{count}} puncte',
  text_other: 'Câștigă {{count}} puncte',
};
